import { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

import RobaCard from '../components/RobaCard.jsx'
import LoaderModal from '../components/LoaderModal.jsx'
import AddNewRobaButton from '../components/AddNewRobaButton.jsx';
import CategorySection from '../components/CategorySection.jsx';

const LoggedHomePage = () => {

  //----- CATTURA DATI UTENTE-----//

  const userToken = localStorage.getItem('loggedUser');
  const decodedToken = jwtDecode(userToken);

  // ----- CHIAMATA FETCH PER RICEVERE GLI OGGETTI ROBA ----- //

  const [robaArray, setRobaArray] = useState([]);
  const [isFetchPending, setIsFetchPending] = useState(true);

  const getRobaData = async () => {

    setIsFetchPending(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba?lat=${decodedToken.position.coordinates.lat}&lng=${decodedToken.position.coordinates.lng}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      })

        if(response.ok) {
          const robaData = await response.json();
          setRobaArray(robaData.payload);
        } else {
          console.log(response);
        }

      } catch (error) {
        console.log('Error type: ', error);
      }



      setIsFetchPending(false);
  }

  useEffect(() => {
    getRobaData();
  }, []);

  useEffect(() => {
    console.log('robaArray: ', robaArray);
  }, [robaArray])

  // ----- //

  return (
    <div className="container">
      
      {/* <Cerca per categoria /> */}
      <CategorySection />

      <h2><span style={{ color: '#94A684', fontSize: '50pt'}}>{robaArray.length}</span> oggetti totali trovati.</h2>

      <h3>Ecco gli oggetti offerti intorno a te:</h3>
        {/* <Ultimi oggetti inseriti nel tuo paese /> */}
        
        <div className="roba-box-container">
        {

          robaArray &&

          robaArray.length !== 0 && robaArray.map((element) => (

            element.supplier._id !== decodedToken.id && element.available && (
              <RobaCard key={element._id} data={element} userCoordinates={decodedToken.position.coordinates} userId={decodedToken.id}/>
            )

          ))

        }
        </div>

        {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}

        <AddNewRobaButton />
    </div>

  )
}

export default LoggedHomePage;
